'use client';

import { c as _c } from "react/compiler-runtime";
import { Stack } from '@mui/material';
import { PASSWORDS_DO_NOT_MATCH_MESSAGE } from './authChallengeError';
import { InlineErrorField } from './inlineErrorField';

// The "new password" + "confirm new password" pair shared by the forced
// password change and the forgot-password reset. Confirm shows the mismatch
// message inline; the parent owns the values and any server-side new-password
// error.
export const NewPasswordFields = t0 => {
  const $ = _c(15);
  const {
    idPrefix,
    newPassword,
    confirmPassword,
    onNewPasswordChange,
    onConfirmPasswordChange,
    newPasswordAutoFocus: t1,
    newPasswordError: t2
  } = t0;
  const newPasswordAutoFocus = t1 === undefined ? false : t1;
  const newPasswordError = t2 === undefined ? null : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      gap: "12px"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const t4 = `${idPrefix}-new-password`;
  let t5;
  if ($[1] !== newPassword || $[2] !== newPasswordAutoFocus || $[3] !== newPasswordError || $[4] !== onNewPasswordChange || $[5] !== t4) {
    t5 = <InlineErrorField id={t4} label="New password" type="password" autoFocus={newPasswordAutoFocus} value={newPassword} onChange={onNewPasswordChange} errorMessage={newPasswordError} />;
    $[1] = newPassword;
    $[2] = newPasswordAutoFocus;
    $[3] = newPasswordError;
    $[4] = onNewPasswordChange;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = `${idPrefix}-confirm-password`;
  const t7 = confirmPassword.length > 0 && confirmPassword !== newPassword ? PASSWORDS_DO_NOT_MATCH_MESSAGE : null;
  let t8;
  if ($[7] !== confirmPassword || $[8] !== onConfirmPasswordChange || $[9] !== t6 || $[10] !== t7) {
    t8 = <InlineErrorField id={t6} label="Confirm new password" type="password" value={confirmPassword} onChange={onConfirmPasswordChange} errorMessage={t7} />;
    $[7] = confirmPassword;
    $[8] = onConfirmPasswordChange;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t5 || $[13] !== t8) {
    t9 = <Stack sx={t3}>{t5}{t8}</Stack>;
    $[12] = t5;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
};